export interface CoinflowInputCss {
  base: string;
  focus: string;
  error: string;
  cvv: { base: string; focus: string; error: string };
}

/**
 * One source for the Coinflow-hosted card/CVV iframe styles; only the focus
 * accent differs per flow. Accent strings stay at the call sites — they are
 * flow theme decisions (gaming '#7332f5 2px solid', merch '#94ff2a 1px solid')
 * and exporting constants here would invite cross-flow reuse of the wrong one.
 */
export function buildCoinflowInputCss(focusBorder: string): CoinflowInputCss {
  const base = `
    background: #27232B;
    padding: 0 8px;
    margin: 0;
    width: 100%;
    font-size: 13px;
    color: white;
    line-height: 48px;
    height: 56px;
    border: none;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  `;
  const focus = `
    border: ${focusBorder};
    outline: 0;
  `;
  const error = 'box-shadow: 0 0 6px 0 #40000d; border: 1px solid #40000d;';

  return { base, focus, error, cvv: { base, focus, error } };
}
